module.exports = __webpack_public_path__ + "img/artboard5.254ae70d.png";